import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Logo } from "@/components/Logo";
import { Seo } from "@/components/Seo";

export const CitySelect = () => {
  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center px-4 relative overflow-hidden" data-testid="city-select-page">
      <Seo
        title="HÖR on Tour — Halloween Edition 2026 | Delhi & Bangalore"
        description="HÖR Berlin's underground Halloween takeover arrives in Delhi (30 Oct) and Bangalore (31 Oct) 2026, featuring BIIA, TIGERHEAD & DØMINA. Tickets from ₹999."
      />
      <div className="absolute inset-0 tile-grid opacity-50" />
      <div className="absolute inset-0 radial-fade-acid" />
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        className="relative z-10 flex flex-col items-center text-center"
      >
        <Logo className="text-3xl mb-6" />
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-acid mb-2">
          Halloween Edition 2026
        </p>
        <h1 className="font-display font-extrabold uppercase text-4xl sm:text-5xl tracking-tight mb-10">
          Choose Your City
        </h1>
        <div className="flex flex-col sm:flex-row gap-4">
          <Link
            to="/delhi"
            data-testid="city-toggle-delhi"
            className="border border-acid text-acid font-display font-bold uppercase tracking-wide text-lg px-10 py-5 hover:bg-acid hover:text-black transition-colors duration-300"
          >
            Delhi · 30 Oct
          </Link>
          <Link
            to="/bangalore"
            data-testid="city-toggle-bangalore"
            className="border border-acid text-acid font-display font-bold uppercase tracking-wide text-lg px-10 py-5 hover:bg-acid hover:text-black transition-colors duration-300"
          >
            Bangalore · 31 Oct
          </Link>
        </div>
      </motion.div>
    </div>
  );
};
